import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { COMPARE_PRICE, PRICE } from '../data/content';
const recap = ['6 volume', '5 bonusuri', '240 de pagini', '4–15 ani'];
const reassurances = ['Descărcare imediată', 'PDF de printat', 'Garanție de satisfacție 7 zile'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15c2ct4olafps">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbagoavp6c0b" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1ec7inae4x61u">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t2ewfct760w7">
          Antrenamentele tale de judo pot fi <em className="text-red-700" data-id="element-118" data-mp="223mjeyq9jfaz">gata chiar de azi.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="221jt0dl77k5q">
          În loc să cauți exerciții, să scrii fiecare antrenament și să-ți petreci duminicile seara cu planificarea,
          ai un pachet de antrenament bine organizat pentru tot sezonul. Mai mult timp pentru
          ce contează cu adevărat:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x3ir5lpywdd6">
          Sportivii tăi. Clubul tău. Viața ta în afara tatamiului.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="164gojl5whmms">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b2i59zfut9v3">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b1713yihy03g">
          <s className="mr-3 align-middle text-3xl text-slate-900/40 sm:text-4xl" data-id="element-124" data-mp="1ktd2fyun1tvb"><span className="sr-only" data-id="element-125" data-mp="1ksl4wihhdm2e">Inițial </span>{COMPARE_PRICE}</s>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-126" data-mp="1puaia4s6ebtn">Plată unică – fără abonament.</p>

        <div className="mt-8 flex justify-center" data-id="element-127" data-mp="1tuknhf858y7g">
          <CtaButton className="w-full sm:w-auto" data-id="element-128" data-mp="3qufe7qwhlmso" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-129" data-mp="3qskugfwyc0q6">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-130" data-mp="3hcu9jzkvh3j">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-131" data-mp="3jpjmi7o0tqm" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}